import { RoutePath } from '@components/AppRouter/constants';
import { ReportGroupEdit } from '@components/dictionary/ReportGroups/ReportGroupEdit';
import { ReportGroups } from '@components/dictionary/ReportGroups/ReportGroups';

import { ControlApplicability } from '../../../dictionary/ControlApplicability/ControlApplicability';
import { ControlApplicabilityEdit } from '../../../dictionary/ControlApplicability/ControlApplicabilityEdit';
import { ControlGroupEdit } from '../../../dictionary/ControlGroups/ControlGroupEdit';
import { ControlGroups } from '../../../dictionary/ControlGroups/ControlGroups';
import { ControlEdit } from '../../../dictionary/Controls/ControlEdit';
import { Controls } from '../../../dictionary/Controls/Controls';
import { ControlVersionEdit } from '../../../dictionary/ControlVersions/ControlVersionEdit';
import { ControlVersions } from '../../../dictionary/ControlVersions/ControlVersions';
import { Counterparties } from '../../../dictionary/Counterparties/Counterparties';
import { CounterpartyEdit } from '../../../dictionary/Counterparties/CounterpartyEdit';
import { IndicatorEdit } from '../../../dictionary/Indicators/IndicatorEdit';
import { Indicators } from '../../../dictionary/Indicators/Indicators';
import { OrganizationCard, Organizations } from '../../../dictionary/Organization';
import { ReportPeriodEdit } from '../../../dictionary/ReportPeriods/ReportPeriodEdit';
import { ReportPeriods } from '../../../dictionary/ReportPeriods/ReportPeriods';
import { ReportEdit } from '../../../dictionary/Reports/ReportEdit';
import { Reports } from '../../../dictionary/Reports/Reports';
import { ReportSettingEdit } from '../../../dictionary/ReportSettings/ReportSettingEdit';
import { ReportSettings } from '../../../dictionary/ReportSettings/ReportSettings';
import { ReportVersionEdit } from '../../../dictionary/ReportVersions/ReportVersionEdit';
import { ReportVersions } from '../../../dictionary/ReportVersions/ReportVersions';
import type { Route } from '../../types';

export const dictionaryConfig: Route = {
  title: 'Справочники',
  icon: 'dictionaryHome',
  routes: [
    {
      title: 'Основные',
      resourceName: ['CmOrganization', 'CmReportPeriods'],
      routes: [
        {
          title: 'Общая информация об организации',
          path: `${RoutePath.ORGANIZATION_CARD}/:code`,
          component: OrganizationCard,
          resourceName: 'CmOrganization',
          hidden: true,
        },
        {
          title: 'Организационная структура',
          path: RoutePath.ORGANIZATIONS,
          component: Organizations,
          resourceName: 'CmOrganization',
        },
        {
          title: 'Календарь отчетных форм',
          path: RoutePath.DICTIONARY_REPORT_PERIODS,
          component: ReportPeriods,
          resourceName: 'CmReportPeriods',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_PERIODS}/:reportGroupCode/:periodCode?`,
          component: ReportPeriodEdit,
          hidden: true,
          resourceName: 'CmReportPeriods',
        },
        {
          title: 'Контрагенты',
          path: RoutePath.DICTIONARY_COUNTERPARTIES,
          component: Counterparties,
          resourceName: 'CmPartners',
        },
        {
          path: `${RoutePath.DICTIONARY_COUNTERPARTIES}/:code/:counterpartyTypeCode?/:orgLocal?`,
          component: CounterpartyEdit,
          hidden: true,
          resourceName: 'CmPartners',
        },
      ],
    },
    {
      title: 'Отчетность',
      resourceName: ['CmReport', 'CmReportVersion', 'CmReportSettings', 'CmReportGroup'],
      routes: [
        {
          title: 'Группы отчетности',
          path: RoutePath.DICTIONARY_REPORT_GROUPS,
          component: ReportGroups,
          resourceName: 'CmReportGroup',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_GROUPS}/:code`,
          component: ReportGroupEdit,
          hidden: true,
          resourceName: 'CmReportGroup',
        },
        {
          title: 'Отчеты',
          path: RoutePath.DICTIONARY_REPORT,
          component: Reports,
          resourceName: 'CmReport',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT}/:code`,
          component: ReportEdit,
          hidden: true,
          resourceName: 'CmReport',
        },
        {
          title: 'Версии отчетов',
          path: RoutePath.DICTIONARY_REPORT_VERSION,
          component: ReportVersions,
          resourceName: 'CmReportVersion',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_VERSION}/:code`,
          component: ReportVersionEdit,
          hidden: true,
          resourceName: 'CmReportVersion',
        },
        {
          title: 'Настройка отчетов',
          path: RoutePath.DICTIONARY_REPORT_SETTINGS,
          component: ReportSettings,
          resourceName: 'CmReportSettings',
        },
        {
          path: `${RoutePath.DICTIONARY_REPORT_SETTINGS}/:code`,
          component: ReportSettingEdit,
          hidden: true,
          resourceName: 'CmReportSettings',
        },
      ],
    },
    {
      title: 'Бизнес-контроли',
      resourceName: ['CmControl', 'CmControlVersion', 'CmIndicator', 'CmControlApplicability', 'CmGroupControl'],
      routes: [
        {
          title: 'Группы контролей',
          path: RoutePath.DICTIONARY_CONTROL_GROUPS,
          component: ControlGroups,
          resourceName: 'CmGroupControl',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_GROUPS}/:ctrlGroupCode`,
          component: ControlGroupEdit,
          hidden: true,
          resourceName: 'CmGroupControl',
        },
        {
          title: 'Контроли',
          path: RoutePath.DICTIONARY_CONTROLS,
          component: Controls,
          resourceName: 'CmControl',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROLS}/:ctrlCode`,
          component: ControlEdit,
          hidden: true,
          resourceName: 'CmControl',
        },
        {
          title: 'Версии контролей',
          path: RoutePath.DICTIONARY_CONTROL_VERSIONS,
          component: ControlVersions,
          resourceName: 'CmControlVersion',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_VERSIONS}/:ctrlVersCode`,
          component: ControlVersionEdit,
          hidden: true,
          resourceName: 'CmControlVersion',
        },
        {
          title: 'Показатели',
          path: RoutePath.DICTIONARY_INDICATORS,
          component: Indicators,
          resourceName: 'CmIndicator',
        },
        {
          path: `${RoutePath.DICTIONARY_INDICATORS}/:varCode`,
          component: IndicatorEdit,
          hidden: true,
          resourceName: 'CmIndicator',
        },
        {
          title: 'Применимости контролей',
          path: RoutePath.DICTIONARY_CONTROL_APPLICABILITY,
          component: ControlApplicability,
          resourceName: 'CmControlApplicability',
        },
        {
          path: `${RoutePath.DICTIONARY_CONTROL_APPLICABILITY}/:ctrlVersCode/:orgCode?`,
          component: ControlApplicabilityEdit,
          hidden: true,
          resourceName: 'CmControlApplicability',
        },
      ],
    },
  ],
};
